import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'icomoon';
    src: url("/fonts/icomoon/icomoon.eot?3hy8rd");
    src: url("/fonts/icomoon/icomoon.eot?3hy8rd#iefix") format("embedded-opentype"),
      url("/fonts/icomoon/icomoon.woff2?3hy8rd") format("woff2"),
      url("/fonts/icomoon/icomoon.ttf?3hy8rd") format("truetype"),
      url("/fonts/icomoon/icomoon.woff?3hy8rd") format("woff"),
      url("/fonts/icomoon/icomoon.svg?3hy8rd#icomoon") format("svg");
    font-display: fallback;
  }

  @font-face {
    font-family: 'the_overleysregular';
    src: url('/fonts/theoverleys/the_overleys-webfont.woff2') format('woff2'),
         url('/fonts/theoverleys/the_overleys-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
   }
  
  html {
    box-sizing: border-box;
    font-size: 16px;
    line-height: 1.625em;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    font-size: inherit;
    font-family: "museo-sans",Helvetica,sans-serif;
    font-weight: 300;
    line-height: inherit;
    color: #333;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5 {
    font-family: "museo-sans-condensed", sans-serif;
  }

  h2, h3 {
    font-size: 1.625em;
    line-height: 1.33333em;
    margin-bottom: 0.5em;
  }

  a {
    color: ${(props) => props.theme.colours.primary};
    font-weight: 600;
    text-decoration: none;
  }
`;
